import { InputRow } from '../InputRow';

export function LimeInstanceInputs({ rx }) {
  return (
    <>
      <InputRow name="Ref Lime Quality" value={rx?.referenceQuality} />
      <InputRow name="Lime Quality" value={rx?.quality} />
    </>
  );
}
